// extracted by mini-css-extract-plugin
export default {"trigger":"FaqListItem_trigger__FmsUT","trigger--open":"FaqListItem_trigger--open__Yx3TR","content":"FaqListItem_content__sLzg3"};